export class Error {
  message: any;
  name?: any;
  status?: any;
  statusText?: any;
}
